export const PASSWORD_TYPE_CONSTANTS = {
  CONFIRM: "confirm",
  LOGIN_ERROR_MESSAGE: "Login Failed",
  LOGIN_SUCCESS_MESSAGE: "Login Successful",
  NEW: "new",
  OLD: "old",
  PASSWORD_LABEL_CONFIRM: "Confirm Password",
  PASSWORD_LABEL_NEW: "New Password",
  PASSWORD_LABEL_OLD: "Old Password",
  PASSWORD_REGEX: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=]).{8,}$/,
};
